import { useEffect } from 'react';

export function useKeepPageInRange(
  page: number,
  totalPages: number | undefined,
  onPageChange: (page: number) => void,
) {
  useEffect(() => {
    if (totalPages === undefined || totalPages < 1) return;
    if (page > totalPages) onPageChange(totalPages);
  }, [page, totalPages, onPageChange]);
}
